<template>
  <a-modal
    class="register_modal"
    v-model:open="visible"
    :title="stepTitle[step - 1]"
    @cancel="handleCancel"
    :footer="null"
    :width="isShowInvitationCode ? '640px' : '520px'"
  >
    <template v-if="step === 1">
      <div class="tip">
        <span>Already have an account ?</span>
        <router-link to="/" class="link" @click.prevent="openLoginModal">Login</router-link>
      </div>
      <a-tabs v-model:activeKey="formState.type">
        <a-tab-pane key="seeker" tab="Job hunting"></a-tab-pane>
        <a-tab-pane key="recruiter" tab="Recruiting"></a-tab-pane>
      </a-tabs>
      <a-form ref="formRef1" :model="formState" class="modal_form">
        <div v-if="isShowInvitationCode" class="invitation_wrapper">
          <div class="invitation_tips">
            <img class="hand_up_img" src="@/assets/images/hand_up.svg" alt="Hand Up Icon" />
            <div class="tips_text">
              <div class="tips_title">Request Early Access</div>
              <div class="tips_desc">
                Private beta · Invitation only · Need a code? Email
                <a class="tips_mail" href="mailto:hello@joylanders.com">hello@joylanders.com</a>
              </div>
            </div>
          </div>
          <a-form-item
            validateTrigger="submit"
            label=""
            name="invitationCode"
            :rules="[{ required: true, message: 'Please enter a 6-digit invitation code' }]"
          >
            <a-input v-model:value="formState.invitationCode" placeholder="Please enter a 6-digit invitation code" />
          </a-form-item>
        </div>
        <EmailInputItem @change-email="handleChangeEmail" />
        <a-form-item
          validateTrigger="submit"
          label=""
          name="emailCode"
          :rules="[{ required: true, message: 'Enter code' }]"
        >
          <a-input v-model:value="formState.emailCode" :placeholder="codePlaceholder" />
          <button
            class="send_code_btn"
            @click.prevent="sendSMSCode"
            :disabled="isSMSCodeDisabled || isSending"
            :style="{ color: sendSMSCodeText !== 'Send code' || isSending ? 'rgba(61, 61, 61, 0.5)' : '' }"
          >
            <LoadingOutlined v-if="isSending" spin />
            {{ sendSMSCodeText }}
          </button>
        </a-form-item>
        <div class="message">
          By clicking "Agree and Join" or "Continue", you agree to abide by JOYJOBS's
          <a href="javascript:void(0);" @click="openLink('/termsOfService')">《Terms of Service》</a>,
          <a href="javascript:void(0);" @click="openLink('/privacyPolicy')">《Privacy Policy》</a>and
          <a href="javascript:void(0);" @click="openLink('/cookiePolicy')">《Cookie Policy》</a>
        </div>
        <a-button
          type="primary"
          html-type="button"
          class="next_btn"
          @click.prevent="handleStep1Submit"
          :disabled="isSubmitDisabled"
        >
          Agree and join
          <ArrowRightOutlined class="btn_arrow" />
        </a-button>
      </a-form>
    </template>
    <template v-else-if="step === 2">
      <div class="tip">
        <span>This name will be used on your resume</span>
      </div>
      <a-form ref="formRef2" :model="formState" class="modal_form">
        <div class="flex_box">
          <a-form-item
            validateTrigger="blur"
            label=""
            name="firstName"
            :rules="[{ required: true, message: 'Enter firstName' }]"
          >
            <a-input v-model:value="formState.firstName" placeholder="First Name" :maxlength="20" />
          </a-form-item>
          <a-form-item
            validateTrigger="blur"
            label=""
            name="lastName"
            :rules="[{ required: true, message: 'Enter lastName' }]"
          >
            <a-input v-model:value="formState.lastName" placeholder="Last Name" :maxlength="20" />
          </a-form-item>
        </div>
        <div class="flex_box">
          <a-form-item
            validateTrigger="blur"
            label=""
            name="nickName"
            :rules="[{ required: formState.useNicknameInResume, message: 'Enter nickName' }]"
          >
            <a-input v-model:value="formState.nickName" placeholder="Nick Name" :maxlength="20" />
          </a-form-item>
          <a-form-item class="switch_item" validateTrigger="blur" label="">
            <a-switch v-model:checked="formState.useNicknameInResume" />
            <span class="switch_tips">Using a nickname in a resume</span>
          </a-form-item>
        </div>
        <a-form-item validateTrigger="change" label="" name="password" :rules="[{ validator: validatePass1 }]">
          <a-input-password
            v-model:value="formState.password"
            placeholder="Enter password"
            autocomplete="new-password"
            :visibilityToggle="true"
          />
          <div v-if="isShowValidPwd" class="valid_pwd">
            <img
              v-if="isValidPwdCharacter"
              class="pwd_icon"
              src="@/assets/images/pwd_success.svg"
              alt="Validation Icon"
            />
            <img
              v-if="!isValidPwdCharacter"
              class="pwd_icon"
              src="@/assets/images/pwd_error.svg"
              alt="Validation Icon"
            />
            <span :class="{ valid_success: isValidPwdCharacter }">The password must contain letters and numbers</span>
          </div>
          <div v-if="isShowValidPwd" class="valid_pwd">
            <img v-if="isValidPwdLength" class="pwd_icon" src="@/assets/images/pwd_success.svg" alt="Validation Icon" />
            <img v-if="!isValidPwdLength" class="pwd_icon" src="@/assets/images/pwd_error.svg" alt="Validation Icon" />
            <span :class="{ valid_success: isValidPwdLength }">The password must be at least 8 characters long</span>
          </div>
        </a-form-item>
        <a-form-item validateTrigger="blur" label="" name="confirmPassword" :rules="[{ validator: validatePass2 }]">
          <a-input-password
            v-model:value="formState.confirmPassword"
            placeholder="Enter again"
            autocomplete="off"
            :visibilityToggle="true"
          />
        </a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          class="submit_btn"
          @click.prevent="handleStep2Submit"
          :disabled="isSubmitDisabled"
        >
          Complete Registration
          <ArrowRightOutlined class="btn_arrow" />
        </a-button>
      </a-form>
    </template>
    <template v-else-if="step === 3">
      <div class="register_success">
        <img src="@/assets/images/register_success.svg" class="success_icon" alt="Registration Successful" />
        <div class="text">Success</div>
        <template v-if="formState.type == 'seeker'">
          <a-button type="primary" class="resume_btn submit_btn" @click.prevent="handleOpenResumeGuideModal">
            <img src="@/assets/images/resume.svg" alt="" />
            Start creating my resume
          </a-button>
          <span class="edit_later" @click="handleCancel">Edit it later</span>
        </template>
        <template v-else>
          <a-button type="primary" class="resume_btn submit_btn" @click.prevent="handleOpenBusinessVerifyModal">
            <img src="@/assets/images/business.svg" alt="" />
            Verify Your Business
          </a-button>
          <span class="edit_later" @click="handleCancel">Skip for Now</span>
        </template>
      </div>
    </template>
  </a-modal>
  <ResumeGuideModal ref="ResumeGuideModalRef" />
  <BusinessVerifyModal ref="BusinessVerifyModalRef" />
</template>

<script setup>
import { ArrowRightOutlined, LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import Cookies from 'js-cookie';
import { ref, defineExpose, defineEmits, toRaw, reactive, onMounted } from 'vue';
import { useStore } from 'vuex';

import BusinessVerifyModal from './BusinessVerifyModal.vue';
import EmailInputItem from './EmailInputItem.vue';
import ResumeGuideModal from './ResumeGuideModal.vue';

import { registerVerifyCode, registerSubmit, registerSendCodeV2, fetchCheckRequired } from '@/api/account/register.js';

const store = useStore();

const visible = ref(false);
const step = ref(1);
const stepTitle = ref(['Choose your role and sign up', 'Enter your real name and password', '']);
const emit = defineEmits(['open-login']);
const formRef1 = ref(null);
const formRef2 = ref(null);
const formState = reactive({
  email: '',
  emailCode: '',
  firstName: '',
  lastName: '',
  nickName: '',
  useNicknameInResume: '',
  password: '',
  confirmPassword: '',
  type: 'seeker',
  loginDevice: 1, //1为电脑端，2位手机端，3为app端
  invitationCode: '',
});

const isSubmitDisabled = ref(false);
const isSMSCodeDisabled = ref(false);
const isSending = ref(false);
const intervalId = ref(null);
const codePlaceholder = ref('Click "Send code" to get the verification code');
const sendSMSCodeText = ref('Send code');
const isShowValidPwd = ref(false);
const isValidPwdCharacter = ref(false);
const isValidPwdLength = ref(false);

const handleCancel = () => {
  visible.value = false;
  step.value = 1; // Reset to step 1
};

const openLoginModal = () => {
  visible.value = false;
  emit('open-login');
};

const handleChangeEmail = (email) => {
  formState.email = email;
};

const validatePass1 = async (_rule, value) => {
  isShowValidPwd.value = true;
  if (!/(?=.*[a-zA-Z])(?=.*[0-9])/.test(value)) {
    isValidPwdCharacter.value = false;
  } else {
    isValidPwdCharacter.value = true;
  }
  if (value.length < 8) {
    isValidPwdLength.value = false;
  } else {
    isValidPwdLength.value = true;
  }
  if (!isValidPwdCharacter.value || !isValidPwdLength.value) {
    return Promise.reject();
  } else {
    return Promise.resolve();
  }
};

const validatePass2 = async (_rule, value) => {
  if (value === '') {
    return Promise.reject('Enter a new password');
  } else if (value !== formState.password) {
    return Promise.reject('The two passwords do not match');
  } else {
    return Promise.resolve();
  }
};

const startCountdown = (time) => {
  if (!time) return;
  if (intervalId.value) clearInterval(intervalId.value);
  isSMSCodeDisabled.value = true;
  var timeLeft = time;
  intervalId.value = setInterval(() => {
    if (timeLeft > 0) {
      timeLeft--;
      sendSMSCodeText.value = timeLeft + ' resend';
    } else {
      clearInterval(intervalId.value);
      timeLeft = 60;
      isSMSCodeDisabled.value = false;
      sendSMSCodeText.value = 'Send code';
    }
  }, 1000);
};

const sendSMSCode = () => {
  formRef1.value.validateFields(['email']).then(() => {
    isSending.value = true;
    codePlaceholder.value = 'Enter code';
    registerSendCodeV2({
      email: formState.email,
      invitationCode: formState.invitationCode,
    }).then((res) => {
      isSending.value = false;
      startCountdown(60);
      if (res.code == 0) {
        message.success(res.msg);
      } else {
        message.error(res.msg);
      }
    }).catch(() => {
      isSending.value = false;
    });
  });
};

const handleStep1Submit = () => {
  if (!isSMSCodeDisabled.value && formState.emailCode === '') {
    sendSMSCode();
    return;
  }
  formRef1.value.validate().then(() => {
    isSubmitDisabled.value = true;
    registerVerifyCode({
      email: formState.email,
      emailCode: formState.emailCode,
      invitationCode: formState.invitationCode,
    }).then((res) => {
      isSubmitDisabled.value = false;
      if (res.code == 0) {
        step.value = 2;
      } else {
        message.error(res.msg);
      }
    });
  });
};

const handleStep2Submit = () => {
  formRef2.value.validate().then(() => {
    isSubmitDisabled.value = true;
    registerSubmit(toRaw(formState)).then((res) => {
      isSubmitDisabled.value = false;
      if (res.code == 0) {
        message.success(res.msg);
        localStorage.setItem('hasAccount', '1');
        store.dispatch('login', res.data.loginResult.token);
        store.commit('setCurrentAccount', res.data.loginResult);
        Cookies.set('token', res.data.loginResult.token);
        step.value = 3;
      } else {
        message.error(res.msg);
      }
    });
  });
};

const open = () => {
  visible.value = true;
};

const BusinessVerifyModalRef = ref(null);
const handleOpenBusinessVerifyModal = () => {
  handleCancel();
  BusinessVerifyModalRef.value.open();
};

const ResumeGuideModalRef = ref(null);
const handleOpenResumeGuideModal = () => {
  handleCancel();
  ResumeGuideModalRef.value.open();
};

const openLink = (url) => {
  window.open(url, '_blank');
};

const isShowInvitationCode = ref(false);
const checkInvitationCode = () => {
  fetchCheckRequired().then((res) => {
    if (res.code == 0) {
      isShowInvitationCode.value = res.data.invitationRequired;
    }
  });
};

onMounted(() => {
  checkInvitationCode();
});

defineExpose({
  open,
});
</script>

<style lang="less">
.register_modal {
  color: #05644f;
  font-size: 16px;
  .ant-modal-content {
    border-radius: 20px;
    padding: 32px;
  }
  .ant-modal-title {
    color: #05644f;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
  }
  .ant-modal-close-icon {
    color: #05644f;
  }
  .tip {
    font-weight: 300;
    margin-bottom: 25px;
    color: #888;
    .link {
      font-weight: bold;
      color: #5271ff;
      margin-left: 10px;
    }
  }
  .ant-tabs-nav {
    margin-bottom: 24px;
    &::before {
      display: none;
    }
  }
  .ant-tabs-nav-list {
    width: 100%;
    padding: 2px;
    border: 1px solid rgba(5, 100, 79, 0.5);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
    border-radius: 100px;
    .ant-tabs-tab {
      flex: 1;
      text-align: center;
      display: block;
      .ant-tabs-tab-btn {
        color: #05644f;
        font-size: 18px;
        font-weight: bold;
        line-height: normal;
      }
      &.ant-tabs-tab-active {
        border-radius: 100px;
        background: #05644f;
        .ant-tabs-tab-btn {
          color: #fff;
        }
      }
    }
    .ant-tabs-ink-bar {
      display: none;
    }
  }
  .ant-tabs-nav-operations {
    display: none !important;
  }
  .modal_form {
    .ant-input,
    .ant-input-password {
      border: 1px solid rgba(5, 100, 79, 0.5);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      padding: 10px 24px;
      font-size: 14px;
      color: #05644f;
    }
    .ant-input-password {
      padding: 0 10px 0 0;
      .ant-input {
        border: none;
      }
    }
    .ant-input::placeholder {
      color: rgba(5, 100, 79, 0.33);
    }
    .ant-input-password-icon,
    .ant-input-password-icon:hover {
      color: #05644f;
      font-size: 18px;
    }
    .flex_box {
      display: flex;
      justify-content: space-between;
      .ant-form-item {
        flex: 1;
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
      .switch_item {
        .ant-switch.ant-switch-checked {
          background-color: #05644f;
        }
        .switch_tips {
          margin-left: 8px;
          color: rgba(61, 61, 61, 0.5);
        }
      }
    }
    .ant-form-item-explain-error {
      margin-bottom: 24px;
    }
    .valid_pwd {
      margin: 10px 0;
      font-size: 12px;
      color: #f04646;
      .pwd_icon {
        width: 14px;
        height: 14px;
        margin-right: 6px;
        vertical-align: text-bottom;
      }
      .valid_success {
        color: #05644f;
      }
    }
  }
  .message {
    font-size: 12px;
    text-align: center;
    color: rgba(61, 61, 61, 0.5);
    a {
      color: #05644f;
    }
  }
  .next_btn,
  .submit_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
    display: block;
    width: 100%;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    &:hover {
      background: #05644f;
      color: #fff;
    }
    .btn_arrow {
      margin-left: 10px;
      font-size: 18px;
    }
  }
  .send_code_btn {
    position: absolute;
    right: 24px;
    top: 12px;
    color: #05644f;
    background: transparent;
    border: none;
    cursor: pointer;
    font-weight: 500;
    min-width: 30px;
  }
  .register_success {
    padding-top: 45px;
    text-align: center;
    .success_icon {
      width: 80px;
      height: 80px;
    }
    .text {
      font-size: 24px;
      font-weight: bold;
      margin-top: 10px;
    }
    .resume_btn {
      border: 1px solid rgba(5, 100, 79, 0.5);
      background: transparent;
      color: #05644f;
      font-size: 16px;
      font-weight: normal;
      box-shadow: none;
      img {
        widows: 20px;
        height: 20px;
        margin-right: 10px;
      }
      &:hover {
        background: transparent;
        color: #05644f;
      }
    }
    .edit_later {
      font-size: 16px;
      font-weight: normal;
      text-align: center;
      margin: 20px auto;
      cursor: pointer;
      display: inline-block;
    }
  }
  .invitation_wrapper {
    background: #fef2ea;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 24px;
    .invitation_tips {
      font-size: 14px;
      color: #c25e1b;
      display: flex;
      align-items: center;
      gap: 12px;
      text-align: left;
      margin-bottom: 14px;
      .hand_up_img {
        width: 50px;
        height: 50px;
        flex-shrink: 0;
      }
      .tips_text {
        display: flex;
        flex-direction: column;
        gap: 1px;
        .tips_title {
          font-weight: bold;
        }
        .tips_desc {
          line-height: 1.5;
          .tips_mail {
            color: #05644f;
            font-weight: 500;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
    .ant-form-item,
    .ant-form-item-explain-error {
      margin-bottom: 0;
    }
  }
}
.email_select_dropdown {
  background: #fff;
  min-width: 200px !important;
  padding: 10px;
  .ant-select-item {
    color: #05644f;
    background: #fff;
    &:hover,
    &.ant-select-item-option-active,
    &.ant-select-item-option-selected {
      background: rgba(5, 100, 79, 0.1);
      color: #05644f;
    }
  }
}
</style>
